import Service from "../../../Services/index";
import moment from "moment";

const RentalFee = {
    namespaced: true,
    state: {
        rentalFeeList:[],
        rentalFeeListAll:[],
        rentalFeeForm:{
            id: "",
            rental_name : "",
            count : "",
            rent_price : "",
            bill : "",
            water_price : "",
            employee_id : null,
            date_record : '',
            employee: [],
            electricityBill: [],
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        search:{
            rental_fee: "",
            rental_fee_id: "",
        },


    },
    mutations: {
        GET_RENTAL_FEE: (state, res) => {
            state.rentalFeeList = res.data;
            state.dataPaginate = {
                current_page : res.current_page,
                from : res.form,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            };
        },
        GET_RENTAL_FEE_ALL: (state, data) => {
            state.rentalFeeListAll = data;
        },
        GET_RENTAL_FEE_BY_ID: (state, res) => {
            state.rentalFeeForm = res;
        },
        CLEAR_FORM_DATA : state=>{
            state.rentalFeeForm = {
                id: "",
                rental_name : "",
                count : "",
                rent_price : "",
                water_price : "",
                bill : "",
                date_record : '',
                employee_id : null,
                employee: [],
                electricityBill: [],
            }
        },
        CLEAR_SEARCH : (state) =>{
            state.search = {
                rental_fee: "",
                rental_fee_id: "",
            }
        }
    },
    actions: {
        setRentalFee({commit},page=1){
            return Service.RentalFee.getRentalFee(page).then(data=>{
                commit("GET_RENTAL_FEE",data);
            })
        },
        getRentalFeeAll({commit}){
            return Service.RentalFee.getRentalFeeAll().then(data=>{
                commit("GET_RENTAL_FEE_ALL",data)
            })
        },
        saveRentalFee({commit},{id,data}){
            if(!id){
                return Service.RentalFee.createRentalFee(data).then(res=>{
                    console.log("create");
                });
            }
            else{
                return Service.RentalFee.updateRentalFee(id,data).then(res=>{
                    console.log("update");
                });
            }
        },
        clearFormData({ commit }) {
            commit("CLEAR_FORM_DATA");
        },
        showRentalFeeByID({commit},id){
            return Service.RentalFee.showRentalFee(id).then(res=>{
                commit("GET_RENTAL_FEE_BY_ID",res);
            })
        },
        delete({ commit }, id) {
            return Service.RentalFee.deleteRentalFee(id)
                .then(() => {
                    console.log("delete rental Fee");
                })
                .catch(err => {
                    console.error(err);
                });
        },
        search({commit},data){
            return Service.RentalFee.searchRentalFee(data).then(res=>{
                commit("GET_RENTAL_FEE",res)
            })
        },
        clearSearch({commit}) {
            commit("CLEAR_SEARCH");
        },
    }
};

export default RentalFee;
